import React from 'react';
import Wrapper from './styles';
import { useCartContext } from '../../context/cart_context';
import { formatPrice } from '../../utils/helpers';
import { Link } from 'react-router-dom';
import { useLanguageContext } from '../../context/language_context';

const CartTotals = () => {
  const { total_amount, shipping_fee, cart } = useCartContext();
  const { t, isArabic } = useLanguageContext();

  return (
    <Wrapper style={{ direction: isArabic ? 'rtl' : 'ltr' }}>
      <div>
        <article>
          <h5>
            {t.cart.subtotal} : <span>{formatPrice(total_amount)}</span>
          </h5>
          <p>
            {t.cart.shippingFee} : <span>{shipping_fee === 0 ? t.cart.free : formatPrice(shipping_fee)}</span>
          </p>
          <hr />
          <h4>
            {t.cart.orderTotal} :{' '}
            <span>{formatPrice(total_amount + shipping_fee)}</span>
          </h4>
        </article>
        <Link
          to='/checkout'
          className='btn'
          onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'InitiateCheckout', {
                value: total_amount + shipping_fee,
                currency: 'TND',
                num_items: cart.length,
                content_ids: cart.map(item => item.id),
                content_type: 'product'
              });
            }
          }}
        >
          {t.cart.proceedToCheckout}
        </Link>
      </div>
    </Wrapper>
  );
};

export default CartTotals;
